import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/Login.css';

const ResetPassword = ({ lang }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [pw, setPw] = useState({ newPassword: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ type: '', text: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg({ type: '', text: '' });
    if (pw.newPassword.length < 6) {
      return setMsg({ type: 'error', text: lang.RESET_TOO_SHORT || 'Password must be at least 6 characters.' });
    }
    if (pw.newPassword !== pw.confirmPassword) {
      return setMsg({ type: 'error', text: lang.RESET_MISMATCH || 'Passwords do not match.' });
    }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword: pw.newPassword })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'An error occurred');
      setMsg({ type: 'success', text: lang.RESET_SUCCESS || 'Password reset successful! Redirecting to login...' });
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setMsg({ type: 'error', text: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="login-page">
      <div className="container">
        <motion.div
          className="login-wrapper"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="login-left">
            <div className="login-brand">
              <span className="login-terminal-line">
                {lang.RESET_TERMINAL || 'root@ispclub:~/# ./ispclub --member -resetpw'}
              </span>
              <h1 className="login-title">{lang.RESET_TITLE || 'Reset Password'}</h1>
              <p className="login-desc">
                {lang.RESET_DESC || 'Enter your new password below.'}
              </p>
            </div>
          </div>

          <div className="login-right">
            <form className="login-form" onSubmit={handleSubmit}>
              {!token && (
                <div className="reset-msg error">
                  {lang.RESET_NO_TOKEN || 'Invalid link. Please request a new one.'}
                </div>
              )}
              <div className="form-group">
                <label>{lang.RESET_NEW_PW || 'New Password'}</label>
                <input
                  type="password"
                  value={pw.newPassword}
                  onChange={(e) => setPw({ ...pw, newPassword: e.target.value })}
                  required
                  placeholder={lang.RESET_NEW_PW_PLACEHOLDER || 'Minimum 6 characters'}
                />
              </div>
              <div className="form-group">
                <label>{lang.RESET_CONFIRM_PW || 'Confirm Password'}</label>
                <input
                  type="password"
                  value={pw.confirmPassword}
                  onChange={(e) => setPw({ ...pw, confirmPassword: e.target.value })}
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary login-submit"
                disabled={loading || !token}
              >
                {loading ? (lang.RESET_SUBMITTING || 'Processing...') : (lang.RESET_SUBMIT || 'Reset password')}
              </button>

              {msg.text && <div className={`reset-msg ${msg.type}`}>{msg.text}</div>}

              <Link to="/login" className="login-back-link">
                ← {lang.RESET_BACK || 'Back to login'}
              </Link>
            </form>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ResetPassword;
